import { render } from "./ViewDownload.vue?vue&type=template&id=374e1574&scoped=true"
import script from "./ViewDownload.vue?vue&type=script&lang=js"
export * from "./ViewDownload.vue?vue&type=script&lang=js"

import "./ViewDownload.vue?vue&type=style&index=0&id=374e1574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374e1574"]])

export default __exports__